var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('a-copy',{class:`${_vm.name}__content`,attrs:{"cms":_vm.cms}}),_vm._v(" "),_c('fetch-story',{attrs:{"route":_vm.cms.api_endpoint,"params":{
          sort_by: _vm.cms.api_order || null,
          by_uuids: _vm.cms.api_filter || null,
        },"limit":parseInt(_vm.cms.api_limit) || 0,"offset":parseInt(_vm.cms.api_offset) || 0,"collection":_vm.cms.collection,"entry":"content"},scopedSlots:_vm._u([{key:"default",fn:function({ collection }){return _c('div',{class:`${_vm.name}__practices`},_vm._l((collection),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:index,tag:"component",class:`${_vm.name}__practice`,attrs:{"cms":item},on:{"onPracticeHover":_vm.onPracticeHover}})}),1)}}])}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{class:[`${_vm.name}__description`, _vm.cssClassVisible]},[_c('a-heading',{attrs:{"html-tag":"h6","cms":{ heading: _vm.heading }}}),_vm._v(" "),_c('a-copy',{attrs:{"cms":{ copy: _vm.copy }}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }